import DeviceScreen from 'lib/DeviceScreen';
import config from 'lib/config';

function criteo() {
  const client = window.criteo_q || (window.criteo_q = []);
  return client;
}

function baseEvents() {
  const events = [{ event: 'setAccount', account: config.criteoAccountId }];

  // TODO: ported from legacy app, enable once users are supported
  // only push the customer id if we have it
  // if (_.isPresent(this.customerId())) {
  //   events.push({ event: "setCustomerId", id: this.customerId()});
  // }

  let siteType = 'd'; // desktop
  if (DeviceScreen.isPhone()) {
    siteType = 'm'; // mobile
  }
  events.push({ event: 'setSiteType', type: siteType });

  return events;
}

function trackEvent(event) {
  const events = baseEvents();
  events.push({ event });
  return criteo().push(events);
}

// eslint-disable-next-line import/prefer-default-export
export function trackHomepageView() {
  trackEvent('viewHome');
}
